'use strict';

const appendParamToURL = require('./appendParamToURL');

/**
 * @function
 * @description Appends the parameter 'format=ajax' to a given path
 * @param {String} path the relative path
 */
const ajaxUrl = (path) => {
    return appendParamToURL(path, 'format', 'ajax');
};

module.exports = ajaxUrl;
